<template lang="pug">
  v-card(min-height="80vh")
    v-card-title.pa-0
      v-row.px-5.py-3(no-gutters align="center" :style="`background-color: ${$vuetify.theme.themes[$theme].basic600T08}`")
        v-col.shrink
          v-btn.ml-n3(text icon @click="showModal = !showModal" height)
            eva-icon(name="close-outline" :fill="$vuetify.theme.themes[$theme].basic800" width="24" height="24")
        v-col.ml-3
          p.mb-0.h6.basic800--text Edit {{ income.quotation ? 'quotation' : 'invoice' }}

    v-card-text.px-0.pb-0(id="mainContainer")    
      .by-amount.pa-6.pb-0(v-if="form.type == 'amount'" id="formDataValue")
        .label.basic600--text.text-uppercase {{ income.quotation ? 'Quotation' : 'Invoice' }} amount
        v-text-field.mt-2(v-model='form.data.valueDisplay' placeholder="0" dense outlined height="40" background-color="basic200" :prefix="$currency.symbol" readonly @click="openCalculatorInputDialog = true" hide-details)
      
      .by-item(v-if="form.type == 'item'" id="formDataProducts")
        .pa-6.pb-4
          .product-image.d-flex
            .label.basic600--text.text-uppercase.my-auto Products
            v-spacer
            v-btn.button-AA-tiny.my-auto(color="textColorHint" outlined x-small height="24" :style="{'background-color': $vuetify.theme.themes[$theme].basic600T08}" @click="openAddProductsDialog = true")
              v-icon.mr-1(small) mdi-plus
              | Add product
        v-list.pa-0
          template(v-if="item.quantity > 0" v-for="(item, index) in form.data.products")
            v-list-item.px-6(:key="item.product.id" :style="{'background-color': index % 2 === 0? $vuetify.theme.themes[$theme].basic200 : $vuetify.theme.themes[$theme].basic100}" @click="openAddProductsDialog = true")
              v-list-item-icon
                v-chip(:color="$vuetify.theme.themes[$theme].infoT08" small style="border: 1px solid var(--v-info);")
                  .p2.info500--text x {{ item.quantity }}
              v-list-item-content
                v-list-item-title.s2 {{ item.name || item.product.name }}
                template(v-if="item.addons && addon.quantity_per_set" v-for="addon in item.addons")
                  .mb-0.caption.grey--text.text--darken-1(style="font-size: 12px !important") - {{ addon.name || item.product.name }}
              v-list-item-icon
                v-col.pa-0.text-right
                  .p2 {{ productPrice(item) | displayPrice }}
                  .p2.primary400--text(v-if="productDiscount(item)") - {{ productDiscount(item) | displayPrice }}
            v-divider.basic300

      v-form.py-6(ref="form")
        .px-6
          .label.basic600--text.text-uppercase Description
          v-text-field.mt-2(v-model='form.data.description' background-color="basic200" height="40" outlined dense placeholder="Write a description for this income")

          .label.basic600--text.text-uppercase(id="formDataDate") Date
          v-dialog(v-model='form.data.date.show' width='290px')
            template(v-slot:activator='{ on }')
              v-text-field.mt-2(:value="form.data.date.value" placeholder="Select date" outlined dense background-color="basic200" readonly v-on='on' :rules="rules.is_selected")
                template(v-slot:append)
                  eva-icon(name="chevron-down-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].basic700")
            v-date-picker(v-model='form.data.record_date' color="primary" no-title @change="saveDate()")

          .due-date(v-if="income.payment_status != 'paid'")
            .label.basic600--text.text-uppercase Payment due
            v-dialog(v-model='form.date.show' width='290px')
              v-date-picker(v-model='form.paymentDueDate' color="primary" no-title @change="saveDueDate()")
            v-select.mt-2(v-model="form.paymentDueDate" background-color="basic200" outlined dense hide-no-data hide-details :items="dueDateChoices" item-text="name" item-value="id")
              template(v-slot:append)
                eva-icon(name="chevron-down-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].basic700")

        v-divider.basic300.my-4
        .px-6
          .label.basic600--text.text-uppercase Customer
          v-text-field.mt-2(:value="form.data.customer.name" placeholder="Add customer" outlined dense background-color="basic200" readonly hide-details @click="openAddCustomerDialog = true")
            template(v-slot:append)
              eva-icon(name="edit-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].basic700" @click="openAddCustomerDialog = true")
          
          .notes.mt-4
            .label.basic600--text.text-uppercase Notes
            v-text-field.mt-2(v-model='form.data.notes' placeholder="Write notes here" background-color="basic200" hide-details outlined dense :maxlength="200")
            .guide.mt-3.d-flex
              eva-icon.mr-2(name="info-outline" :fill="$vuetify.theme.themes[$theme].basic600" height="15" width="15")
              div.c1.basic600--text Your customers will see this in their invoices
          
          .discount.mt-4
            v-layout(v-if="invoiceDiscount")
              .s2.primary400--text(v-if="invoiceDiscount.isPercentage") Discount: {{ invoiceDiscount.value }}%
              .s2.primary400--text(v-else) Discount: {{ invoiceDiscount.value | displayPrice }}
              eva-icon.mt-1.ml-2(name="trash-outline" height="16" width="16" :fill="$vuetify.theme.themes[$theme].danger500" @click="invoiceDiscount = null")
            v-btn.button-Aa-medium.custom-transform-class.text-none.px-2.ml-n3(v-else color="textColorAccent" text @click="openEditDiscount = true" small)
              eva-icon.mt-1.mr-2(name="plus-outline" :fill="$vuetify.theme.themes[$theme].textColorAccent" height="20" width="20")
              | Add discount

    v-card-actions
      v-col.pa-0
        v-layout.px-4.pt-2
          .s1.textColorDefault--text Total amount:
          .s1.info400--text.ml-2 {{ totalAfterDiscount | displayPrice }}
        v-layout
          v-spacer
          v-btn(color='white', text @click='showModal = false')
            .button-Aa-medium.primary400--text Cancel
          v-btn.mr-2(color='info500' depressed @click="clickProceed()" :loading="loading")
            .button-AA-medium.basic100--text {{ $t('save') }}

    .modals
      CalculatorInput(v-if="openCalculatorInputDialog" :open.sync="openCalculatorInputDialog" :initial="form.data.value" @input="handleInput")
      AddProducts(v-if="isProductsReady" :open.sync="openAddProductsDialog" :initial.sync="form.data.products" @confirm="updateProducts" :isEditing="true")
      AddCustomer(v-if="openAddCustomerDialog" :open.sync="openAddCustomerDialog" :parentCustomer="form.data.customer" @edited="updateCustomer" :company="company")
      AddDiscount(v-if="openEditDiscount" :open.sync="openEditDiscount" :initialDiscount.sync="invoiceDiscount" @added="handleAddDiscount")
      
</template>

<script>
import { DateTime } from 'luxon'
import { mapActions, mapGetters } from 'vuex'
import CalculatorInput from '@/components/yezzabook/dialogs/CalculatorInput.vue'
import AddProducts from '@/components/yezzabook/dialogs/income/addincome/AddProducts.vue'
import AddCustomer from '@/components/yezzabook/dialogs/income/addincome/AddCustomer.vue'
import AddDiscount from '@/components/yezzabook/dialogs/income/addincome/AddDiscount.vue'

export default {
  name: 'RecordIncome',
  props: ['open', 'step', 'loading', 'parentIncome'],
  components: { CalculatorInput, AddProducts, AddCustomer, AddDiscount },
  data: () => ({
    isLoading: false,
    isProductsReady: false,
    openCalculatorInputDialog: false,
    openAddProductsDialog: false,
    openAddCustomerDialog: false,
    openEditDiscount: false,
    selectedType: 0,
    disableQuotation: true,
    invoiceDiscount: null,
    form: { 
      // income
      type: 'amount',
      data: { 
        value: 0,
        valueDisplay: 0,
        products: [],
        record_date: null,
        description: null,
        notes: null,
        date: {
          show: false,
          value: null
        },
        customer: {
          name: "Guest"
        },
        quotation: false
      },
      paymentDueDate: null,
      date: {
        show: false,
        value: null
      }
    },
    dueDateChoices: [],
    originalDateChoices: [],
    options: {
      duration: 200,
      offset: 0,
      easing: 'linear',
      container: '#mainContainer'
    },
    rules: {
      is_selected: [(v) => v !== null || 'This field is required'],
      has_quantity: [(v) => !!v || 'This field is required', (v) => v > 0|| 'This field is required']
    }
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    income: {
      get() {
        return this.parentIncome
      },
      set(newValue) {
        this.$emit('update:parentIncome', newValue)
      }
    },
    totalInvoiceDiscount () {
      if (!this.invoiceDiscount) {
        return 0
      }
      let discountAmount = this.invoiceDiscount.value
      if (this.invoiceDiscount.isPercentage) {
        discountAmount = this.invoiceDiscount.value * (this.form.type == 'amount' ? this.form.data.value : this.totalPrice) / this.$currency.multiplier
      }
      return parseInt(discountAmount)
    },
    totalPrice() {
      let total = 0
      this.form.data.products.forEach(o => {
        let discount = o.discount
        if (o.show_discount_as_percentage) {
          discount = o.discount * o.product.price / this.$currency.multiplier
        }
        let addonprice = 0
        if (o.addons) {
          o.addons.forEach(a => {
            addonprice += (a.price * a.quantity_per_set)
          })
        }
        total += (o.quantity * ((o.product.price - discount) + addonprice))
      })
      return total
    },
    totalAfterDiscount () {
      return (this.form.type == 'amount' ? this.form.data.value : this.totalPrice) - this.totalInvoiceDiscount
    },
    priceRules () {
      return [
        v => !!v || 'Amount is required',
        v => v != 0|| 'Amount is required',
        v => v <= this.totalAfterDiscount/this.$currency.multiplier || `Amount should not be above ${this.$currency.symbol} ${(parseFloat(this.totalAfterDiscount/this.$currency.multiplier)).toFixed(this.$currency.exponent)}`,
      ]
    }
  },
  watch: {
    selectedType (val) {
      if (val === 1) {
        this.form.type = 'item'
      } else {
        this.form.type = 'amount'
      }
      this.$store.commit('ui/setLastIncomeTabPosition', val)
    },
    'form.data.record_date' () {
      if (this.income.quotation) {
        this.form.paymentDueDate = this.income.quotation_due_date
      } else {
        this.form.paymentDueDate = this.income.due_date
      }
      const selectedDate = DateTime.fromFormat(this.form.data.record_date, 'yyyy-MM-dd')
      this.originalDateChoices = [
        { name: `Due ${selectedDate.toFormat('dd/MM/yyyy')}`, id: selectedDate.toFormat('yyyy-MM-dd') },
        { name: 'Within 15 days', id: selectedDate.plus({ days: 15 }).toFormat('yyyy-MM-dd') },
        { name: 'Within 30 days', id: selectedDate.plus({ days: 30 }).toFormat('yyyy-MM-dd') },
        { name: 'Within 45 days', id: selectedDate.plus({ days: 45 }).toFormat('yyyy-MM-dd') },
        { name: 'Within 60 days', id: selectedDate.plus({ days: 60 }).toFormat('yyyy-MM-dd') },
        { name: 'Within 90 days', id: selectedDate.plus({ days: 90 }).toFormat('yyyy-MM-dd') },
        { name: 'Custom', id: 'custom'}
      ]
      this.dueDateChoices = [ ...this.originalDateChoices ]
    },
    'form.paymentDueDate' (val) {
      if (val === 'custom') {
        this.form.date.show = true
        this.form.paymentDueDate = this.form.data.record_date
      }
      if (val) {
        this.dueDateChoices = [ ...this.originalDateChoices ]
        this.dueDateChoices.push({ name: this.formatDate(this.form.paymentDueDate), id: this.form.paymentDueDate})
      } else {
        this.dueDateChoices = [ ...this.originalDateChoices ]
      }
    }
  },
  mounted () {
    if (this.income.type === 'product') {
      this.selectedType = 1
      this.form.data.products = this.income.products
    } else {
      this.form.data.value = this.income.products[0].price
      this.form.data.valueDisplay = this.$options.filters.displayPriceRaw(this.form.data.value)
    }
    this.form.data.description = this.income.description
    this.form.data.notes = this.income.notes
    this.form.data.record_date = DateTime.fromISO(this.income.record_date).toFormat('yyyy-MM-dd')
    this.form.data.date.value = this.formatDate(this.form.data.record_date)
    if (this.income.quotation) {
      this.form.paymentDueDate = this.income.quotation_due_date
    } else {
      this.form.paymentDueDate = this.income.due_date
    }
    this.form.data.customer.name = this.income.name
    this.form.data.customer.phone = this.income.phone
    this.form.data.customer.name = this.income.name
    this.form.data.customer.address = this.income.address
    if (this.income.invoice_discount) {
      this.invoiceDiscount = {
        isPercentage: false,
        value: this.income.invoice_discount
      }
    }
    this.isProductsReady = true
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    handleInput (val) {
      this.form.data.value = (parseFloat(val)).toFixed(this.$currency.exponent).replace('.', '')
      this.form.data.valueDisplay = this.$options.filters.displayPriceRaw(this.form.data.value)
    },
    updateProducts (val) {
      this.form.data.products = [ ...val ]
    },
    updateCustomer (val) {
      this.form.data.customer = val
    },
    saveDate () {
      this.form.data.date.show = false
      this.form.data.date.value = this.formatDate(this.form.data.record_date)
    },
    saveDueDate () {
      this.form.date.show = false
      this.form.date.value = this.formatDate(this.form.paymentDueDate)
    },
    formatDate (date) {
      if (!date) {
        return null
      }
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    clickProceed () {
      let finalData = {}
      // generate income object
      let data = {}
      if (this.form.type === 'amount') {
        if (!this.form.data.value || this.form.data.value === '000') {
          this.showMessage(['error', this.$t('error_message.amount_is_required')])
          this.$vuetify.goTo('#formDataValue', this.options)
          return
        }
        data.amount = this.form.data.value
      } else if (this.form.type === 'item') {
        if (this.form.data.products.length <= 0) {
          this.showMessage(['error', this.$t('error_message.item_is_required')])
          this.$vuetify.goTo('#formDataProducts', this.options)
          return
        }
        data.products = this.finalProducts()
      }
      this.$refs.form.validate()
      if (!this.form.data.record_date) {
        this.showMessage(['error', this.$t('error_message.date_is_required')])
        this.$vuetify.goTo('#formDataDate', this.options)
        return
      }
      data.record_date = DateTime.fromFormat(this.form.data.record_date, 'yyyy-MM-dd')
      if (this.form.data.description) {
        data.description = this.form.data.description
      }
      if (this.form.data.notes) {
        data.notes = this.form.data.notes
      }
      if (this.form.data.customer.name) {
        data.name = this.form.data.customer.name
        if (this.form.data.customer.email) {
          data.email = this.form.data.customer.email
        }
        if (this.form.data.customer.phone) {
          data.phone = this.form.data.customer.phone
        }
        if (this.form.data.customer.address) {
          data.address = this.form.data.customer.address
        }
      } else {
        data.name = 'Amount'
      }
      if (this.income.payment_status != 'paid') {
        if (data.quotation) {
          data.quotation_due_date = this.form.paymentDueDate
        } else {
          data.due_date = this.form.paymentDueDate
        }
      }
      finalData.income = { ...data }
      data = {}
      // generate invoice object
      if (this.totalInvoiceDiscount) {
        data.invoice_discount = this.totalInvoiceDiscount
      } else {
        data.invoice_discount = 0
      }
      finalData.invoice = { ...data }
      this.$emit('edit', finalData)
    },
    handleAddDiscount (val) {
      this.invoiceDiscount = val
    },
    productDiscount (prod) {
      let discount = prod.discount
      if (prod.show_discount_as_percentage) {
        discount = prod.discount * prod.product.price / this.$currency.multiplier
      }
      return prod.quantity * parseInt(discount)
    },
    productPrice (prod) {
      let addonprice = 0
      if (prod.addons) {
        prod.addons.forEach(a => {
          addonprice += (a.price * a.quantity_per_set)
        })
      }
      return (prod.quantity * (prod.product.price + addonprice))
    },
    finalProducts () {
      const products = []
      this.form.data.products.forEach(item => {
        let discount = item.discount
        if (item.show_discount_as_percentage) {
          discount = item.discount * item.product.price / this.$currency.multiplier
        }
        const selectedItem = {
          id: item.id || null,
          product: item.product.id,
          quantity: item.quantity,
          discount: discount || 0,
          show_discount_as_percentage: item.show_discount_as_percentage || false,
        }
        if (item.addons) {
          selectedItem.addons = [...item.addons.map(m => { return {
            id: m.edit_id || null,
            product: m.id,
            quantity_per_set: m.quantity_per_set
          }}).filter(f => (!item.id && f.quantity_per_set > 0) || item.id)]
        }
        products.push(selectedItem)
      })
      return products
    }
  }
}
</script>

<style scoped>
.main-container {
  position: relative;
}
.separator {
  position: absolute;
  height:2px;
  top: 38px;
  left: 0px;
  right: 0px;
}
div >>> .v-list-item--active{
  background-color: var(--v-info500) !important;
  color:white !important;
}
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>

<i18n>
{
  "en": {
    "cancel": "Cancel",
    "save": "Save"
  }
}
</i18n>
